import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Transaction, { Load_Transaction } from "../Transaction/Transaction";
import { Pre_Loading, Show_Message } from "../General/Messagedialogbox";
import { API_POST } from "../General/Utility";
import { Clear_Transaction } from "../features/Transactionstates";

function SalesOrder() {
  const dispatch = useDispatch();
  const _AuthParems = useSelector((state) => state.Common.Admin);
  const _Common = useSelector((store) => store.Transstates.Common);
  const _HT = useSelector((store) => store.Transstates.Header);
  const _DT = useSelector((store) => store.Transstates.Data);
  const _Sum = useSelector((store) => store.Transstates.Summary);
  const _Disc = useSelector((store) => store.Transstates.Discount);

  const _iScrId = 15;

  useEffect(() => {
    Load_Transaction(dispatch, _Common, _iScrId);
  }, []);

  const toDecimal = (val) => {
    const num = Number(val);
    return isNaN(num) ? 0 : num;
  };

  const SaveClick = async () => {
    if ((_DT.arrEntDT ?? []).length === 0) {
      Show_Message(dispatch, "Atleast One Item is Required", "error");
    } else {
      const SalOrdListHT = {
        iBranchId: Number(_AuthParems.Branch),
        iSalOrdId: _HT.iVouchId,
        iTitleTag: _Common.iScrId,
        iPartyId: _HT.iPartyId,
        strShippingAdd:
          _HT.strShippingAdd === "" ? _HT.strPartyAdd : _HT.strShippingAdd,
        iNumSeqNo: _HT.iNumSeqNo,
        strPrefix: _HT.strPrefix,
        strCompCode: _HT.strCompCode,
        strFinanFrom: _HT.strFinanFrom,
        strTransNo: _HT.strTransNo,
        strVouchNo: _HT.strVouchNo,
        strVouchDate: _HT.strVouchDate,
        iAddLessBillDiscId: _Common.iALBillDiscId,
        iBillTypeId: _HT.iBillTypeId,
        iTaxCalcOnId: _Common.iTaxCalcOnId,
        iTaxTypeId: _HT.iTaxRelId,
        iDMId: _HT.iDMId,
        strConvertDCVouch: _HT.strConvertDCVouch,
        strPartyDCVouch: _HT.strPartyDCVouch,
        strRefNum1: _HT.strRefNum1,
        dpRefNum1Date: _HT.dpRefNum1Date,
        strRefNum2: _HT.strRefNum2,
        dpRefNum2Date: _HT.dpRefNum2Date,
        strRefNum3: _HT.strRefNum3,
        dpRefNum3Date: _HT.dpRefNum3Date,
        strRefNum4: _HT.strRefNum4,
        dpRefNum4Date: _HT.dpRefNum4Date,
        strRemark1: _HT.strRemark1,
        strRemark2: _HT.strRemark2,
        strRemark3: _HT.strRemark3,
        strRemark4: _HT.strRemark4,
        strValidity: _HT.strValidity,
        dpValDateUpto: _HT.dpValDateUpto,
        strPayTerm: _HT.strPayTerm,
        dpPayTermDateUpto: _HT.dpPayTermDateUpto,
        strDeliTerm: _HT.strDeliTerm,
        dpDelTermDateUpto: _HT.dpDelTermDateUpto,
        strEComGstNo: _HT.strEComGstNo,
        strTransport: _HT.strTransport,
        strVehicle: _HT.strVehicle,
        strDespatch: _HT.strDespatch,
        dpDespatchDate: _HT.dpDespatchDate,
        strLRNNumber: _HT.strLRNNumber,
        dpLRNoDate: _HT.dpLRNoDate,
        strAgent: _HT.strAgent,
        strReference: _HT.strReference,
        strDestination: _HT.strDestination,

        dTBillDiscPer: toDecimal(_Disc.dBillDisPer),
        dTBillDiscAmt: toDecimal(_Disc.dBillDisAmt),
        dTBillDiscValue: toDecimal(_Disc.dBillDisValue),
        dTAddLessDiscPer: toDecimal(_Disc.dALBillDisPer),
        dTAddLessDiscAmt: toDecimal(_Disc.dALBillDisAmt),
        dTAddLessDiscValue: toDecimal(_Disc.dALBillDisValue),

        dTotQty: toDecimal(_Sum.Qty),
        dTotGoodval: toDecimal(_Sum.GoodsValue),
        dTotDiscount: toDecimal(_Sum.TotalDiscount),
        dTotTax: toDecimal(_Sum.TotalTax),
        dAddLess: toDecimal(_Sum.TotalAddLess),
        dTotTCSTax: toDecimal(_Sum.TotalTCSTax),
        dRoundOff: toDecimal(_Sum.RoundOff),
        dNetAmt: toDecimal(_Sum.NetAmt),
      };
      const res = await API_POST(
        "SalesOrder/InsUpd_SalesOrder/",
        {
          objEntSI: SalOrdListHT,
          objBaseTransDT: _DT.arrEntDT,
          objPenConDT: _DT.arrEntPenCon,
          objEntALDT: _DT.arrEntAL,
          objDTHelp: _DT.arrEntDTHelp,
          objEntTax: _DT.arrEntTax,
          iUserId: Number(_AuthParems.User),
          FYid: Number(_AuthParems.Year),
          strDBName: _AuthParems.DB,
        },
        dispatch
      );
      if (res) {
        Show_Message(dispatch, res.strMessage, "success");
        Clear_Click();
      }
    }
  };

  const Clear_Click = async () => {
    try {
      await Pre_Loading(dispatch, true);
      await dispatch(Clear_Transaction());
      await Load_Transaction(dispatch, _Common, _Common.iScrId);
    } catch (e) {
      await Show_Message(dispatch, e.message, "error");
    } finally {
      await Pre_Loading(dispatch, false);
    }
  };

  return <Transaction Save={SaveClick} ScrId={_iScrId} />;
}
export default SalesOrder;